const ADS = 'alliance';
const RBC = 'rbc';
const InStore = 'in-store/[uuid]';
const Cart = 'cart/[cartID]';
const NoMatch = 'no-match';

export const NAMESPACE_MAP = {
  ADS,
  RBC,
  InStore,
  Cart,
  NoMatch,
} as const;

export type Namespace = keyof typeof NAMESPACE_MAP;
export type NamespacePath = typeof NAMESPACE_MAP[keyof typeof NAMESPACE_MAP];

/**
 * Determine if string is a valid namespace.
 *
 * @param namespace - A namespace string.
 *
 * @returns - Returns boolean to determine if namespace is valid.
 *
 */
export function isNamespaceKey(
  namespace: string | undefined | null
): namespace is Namespace {
  if (!namespace) {
    return false;
  }
  return Object.keys(NAMESPACE_MAP).includes(namespace);
}

const namespaceRegex =
  /^\/(?<tenant>(alliance)|(rbc)|(in-store\/\[uuid\])|(cart\/\[cartID\]))/;

/**
 * Gets namespace from URL.
 *
 * @param pathname - A pathname.
 *
 * @returns - Returns a namespace or undefined.
 *
 */
export function namespaceFromUrl(pathname: string): NamespacePath | undefined {
  const namespaceResult = namespaceRegex.exec(pathname);

  return Object.values(NAMESPACE_MAP).find(
    (t) => t === namespaceResult?.groups?.tenant
  );
}
